exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-icon[data-v-4302dca2]{width:100%;height:100%;margin:auto}.selected-row[data-v-4302dca2]{background-color:#e0e0e0}.low-opacity[data-v-4302dca2]{opacity:.5}.car-data-item[data-v-4302dca2]{padding-right:10px;padding-bottom:10px}.bold[data-v-4302dca2]{font-weight:700}.car-list-item[data-v-4302dca2]{margin:5px;border:1px solid #cbcbcb}", ""]);

// exports
